<template>
    <search-layout
        v-if="loaded"
        :map-expanded="mapExpanded"
        :offers-count="filteredOffers.length"
        :search-active="searchActive"
    >
        <template v-slot:breadcrumbs>
            <expired-offers-snackbar :is-offers-expired="isOffersExpired" @refresh="search" />
            <extra-service-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:left-sidebar>
            <extra-service-search-summary :search-request="searchRequest" />
            <sort-select v-model="sortKey" :items="sortItems" />
            <extra-service-filters
                :filter-values="filterValues"
                :filters="searchResponse.filters"
                :filtered-offers-count="filteredOffers.length"
                :currency="currency"
                @change="changeFilter"
                @reset="resetFilters"
            />
        </template>
        <template v-slot:main-content>
            <search-progress
                :filtered-offers-count="filteredOffers.length"
                :total-offers-count="filteredOffers.length"
                :search-active="searchActive"
                @stop="stopSearch"
            />
            <extra-service-offers :offers="filteredOffers" />
            <pagination v-model="page" :pages="pages" />
            <conditions-modal>
                <template v-slot:info>
                    <extra-service-conditions-modal-info />
                </template>
            </conditions-modal>
            <extra-service-info-modal />
        </template>
        <template v-slot:right-sidebar>
            <client-only>
                <extra-service-map v-model="mapExpanded" :city="city" />
            </client-only>
        </template>
    </search-layout>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import MobileSearchPageTabs from '~src/components/snippets/MobileSearchPageTabs.vue'
    import Pagination from '~src/components/search/Pagination.vue'
    import ConditionsModal from '~src/components/modals/ConditionsModal.vue'
    import ExtraServiceBreadcrumbs from '~src/components/extraServices/ExtraServiceBreadcrumbs.vue'
    import ExtraServiceOffers from '~src/components/extraServices/search/offers/ExtraServiceOffers.vue'
    import ExtraServiceFilters from '~src/components/extraServices/search/ExtraServiceFilters.vue'
    import ExtraServiceSearchSummary from '~src/components/extraServices/search/ExtraServiceSearchSummary.vue'
    import ExtraServiceMap from '@/components/extraServices/search/ExtraServiceMap.vue'
    import ExtraServiceInfoModal from '~src/components/extraServices/info/ExtraServiceInfoModal.vue'
    import {SearchPageBase} from '@/mixins/SearchPageBase.vue'
    import {ExtraServiceStoreMixin} from '@/mixins/ExtraServiceStoreMixin.vue'
    import {ExtraServicePageMixin} from '~src/components/extraServices/mixins/ExtraServicePageMixin.vue'
    import ExpiredOffersSnackbar from '~src/components/search/ExpiredOffersSnackbar.vue'
    import SearchProgress from '~src/components/search/searchProgress.src'
    import SortSelect from '~src/components/search/SortSelect.vue'
    import ExtraServiceConditionsModalInfo from '@/components/extraServices/snippets/ExtraServiceConditionsModalInfo.vue'
    import _Tmp_SearchPageBase, {Tmp_SearchPageBase} from '@/mixins/Tmp_SearchPageBase.vue'
    import SearchLayout from '~src/components/parts/searchLayout.src'
    import {SearchPageMixin} from '@/components/mixins/SearchPageMixin.vue'
    import {useExtraServiceRuntimeData} from '~/composables/extra-service'
    import {callComponentComputed} from '~/utils/vue-class-helpers'

    @Component({
        components: {
            ExtraServiceConditionsModalInfo,
            SortSelect,
            SearchProgress,
            ExpiredOffersSnackbar,
            ExtraServiceOffers,
            Pagination,
            MobileSearchPageTabs,
            ExtraServiceBreadcrumbs,
            ExtraServiceFilters,
            ExtraServiceSearchSummary,
            ExtraServiceMap,
            ExtraServiceInfoModal,
            ConditionsModal,
            SearchLayout,
        },
        async setup() {
            const route = useRoute()
            await useAsyncData(`extra-service-${route.query.cityId}`, async () => {
                await useExtraServiceRuntimeData(route)
                return true
            })
        },
    })
    export class ExtraServicesPage extends mixins(
        ExtraServicePageMixin,
        ExtraServiceStoreMixin,
        SearchPageMixin,
        SearchPageBase,
        Tmp_SearchPageBase
    ) {
        async fetch() {
            await this.loadRuntimeData()
        }

        get city() {
            return this.productRuntimeStore.city
        }

        get mapPoints() {
            const {latitude: lat, longitude: lng} = this.city
            return [{lat, lng}]
        }

        get filteredOffers() {
            const type = this.$route.query.type,
                offers = this.productRuntimeStore.offers
            return !type ? offers : offers.filter(offer => offer.info.name.toLowerCase().includes(type))
        }

        get sortItems() {
            return [
                ...callComponentComputed(this, _Tmp_SearchPageBase, 'sortItems'),
                {
                    text: this.$t('sort.name'),
                    value: 'name',
                },
            ]
        }
    }

    export default ExtraServicesPage
</script>
